import chroma from 'chroma-js';

import { isAdminPage, roundedElements } from 'Services/BaseHelpers';

/**
 * @method getStyles_default
 * @return {object}
 */
const getStyles_default = (error) => {
    if (!isAdminPage()) {
        return {
            control: styles => ({
                ...styles,
                borderWidth: 2,
                borderColor: error ? '#EE3224' : '#B0B0B0', // Updated to grey color
                backgroundColor: '#ffffff',
                color: '#0D1846'
            }),
            singleValue: (provided) => ({
                ...provided,
                color: '#0D1846'
            }),
            multiValueLabel: (provided) => ({
                ...provided,
                color: '#0D1846'
            }),
        }
    }

    return {
        control: styles => ({
            ...styles,
            borderRadius: roundedElements() ? 4 : 0
        })
    }
}

/**
 * Use a different colour for each option.
 * Source: https://react-select.com/styles#select-props
 *
 * @method getStyles_colouredOptions
 * @return {object}
 */
const getStyles_colouredOptions = () => {
    return {
        control: (provided, state) => ({
            ...provided,
            borderColor: '#B0B0B0', // Updated to grey color
            boxShadow: 'none',
            border: 'none',
            backgroundColor: 'transparent',
            iconColor: '#0D1846',
        }),
        placeholder: (provided) => ({
            ...provided,
            color: '#ffffff'
        }),
        indicatorContainer: (provided) => ({
            ...provided,
            color: '#0D1846'  // Set search icon color to blue
        }),
        multiValue: (styles, { data }) => {
            let colors = getStyles_colouredOptions_colors(data.color);

            return {
                ...styles,
                backgroundColor: colors.backgroundColor,
            };
        },
        multiValueLabel: (styles, { data }) => {
            let colors = getStyles_colouredOptions_colors(data.color);

            return {
                ...styles,
                color: colors.textColor,
            };
        },
        multiValueRemove: (styles, { data }) => {
            let colors = getStyles_colouredOptions_colors(data.color);

            return {
                ...styles,
                color: colors.textColor,
                ':hover': {
                    backgroundColor: colors.backgroundColor,
                    color: colors.textColor,
                },
            };
        },
    };
}

/**
 * @method getStyles_colouredOptions_colors
 * @param {string} color
 * @return {object}
 */
const getStyles_colouredOptions_colors = (color) => {
    if (!color) {
        color = '#3685D4';
    }

    return {
        backgroundColor: color,
        focusedBackgroundColor: chroma(color).alpha(0.7).css(),
        textColor: chroma.contrast(color, 'white') > 2 ? 'white' : 'black'
    };
}

export {
    getStyles_default,
    getStyles_colouredOptions
}
